import { DrawerClose, DrawerContent } from '@/modules/components/ui/drawer'
import { X } from 'lucide-react'
import React from 'react'
import { getCategoriesData } from '~shared/api/categories/getCategories'
import { Button } from '~shared/components/button-v2'
import {
  Accordion,
  AccordionContent,
  AccordionHeader,
  AccordionIndicator2,
  AccordionItem,
  AccordionTrigger
} from '~shared/components/accordion'
import { programsFilter } from '~pages/home-page/const/programs-filter'
import { Close } from '~shared/icons/close'

type FiterDrawerProps = {
  categories: Awaited<ReturnType<typeof getCategoriesData>>
  searchParams: TSearchParams
  setSearchParams: React.Dispatch<React.SetStateAction<TSearchParams>>
  setShowedPrograms: React.Dispatch<React.SetStateAction<number>>
}
type TSearchParams = {
  duration: { slug: string; name: string }
  faculty: { slug: string; name: string }
  category: { slug: string; name: string }
  format: { slug: string; name: string }
}
export const FilterDrawer: React.FC<FiterDrawerProps> = ({
  categories,
  setSearchParams,
  searchParams,
  setShowedPrograms
}) => {
  const activeFilters = Object.keys(searchParams).filter(
    key => searchParams[key as keyof TSearchParams].slug !== 'all'
  )
  return (
    <DrawerContent className='container right-0 top-0 bg-white w-full h-full px-[10px] pt-[50px] pb-[16px] box-border flex flex-col '>
      <div className='flex items-center justify-between'>
        <p className='text-[30px] font-medium'>Фильтры</p>
        <span className='cursor-pointer w-[30px] h-[30px] rounded-full bg-[#F2F2F2] flex items-center justify-center'>
          <DrawerClose asChild>
            <X className='max-h-[17px] max-w-[17px]' />
          </DrawerClose>
        </span>
      </div>
      {activeFilters.length > 0 && (
        <div className='mt-[24px] flex gap-[8px] flex-wrap'>
          {activeFilters.map(item => (
            <Button
              key={item}
              onClick={() =>
                setSearchParams(prev => {
                  return {
                    ...prev,
                    [item]: {
                      name: '',
                      slug: 'all'
                    }
                  }
                })
              }
              className='h-[40px] bg-[#3A52EE1A] duration-300 ease-in-out text-accent px-[12px] hover:bg-accent hover:text-white text-[14px] gap-[8px]'>
              {item === 'duration' ? 'Длительность ' : ''}
              {searchParams[item as keyof TSearchParams].name}
              <Close />
            </Button>
          ))}
          <Button
            className='h-[40px] bg-[#3A52EE1A] duration-300 ease-in-out text-accent px-[12px] hover:bg-accent hover:text-white text-[14px] gap-[8px]'
            onClick={() => {
              setSearchParams({
                duration: { slug: 'all', name: '' },
                faculty: { slug: 'all', name: '' },
                category: { slug: 'all', name: '' },
                format: { slug: 'all', name: '' }
              })
              setShowedPrograms(6)
            }}>
            Сбросить все
            <Close />
          </Button>
        </div>
      )}
      <div className='my-[24px] pr-[10px] max-h-[calc(100dvh-200px)] overflow-y-auto'>
        <Accordion type='multiple' className='grid grid-cols-1  gap-[24px] '>
          {programsFilter(categories)
            .slice(1, 5)
            .map(el => (
              <AccordionItem
                key={el.filterName.slug}
                value={el.filterName.name ?? ''}
                className='self-start'>
                <AccordionHeader>
                  <AccordionTrigger className='p-0'>
                    {el.filterName.name ?? ''}
                    <AccordionIndicator2 />
                  </AccordionTrigger>
                </AccordionHeader>

                <AccordionContent className='p-0 pt-[16px]'>
                  <div className='flex flex-col gap-[16px]'>
                    {el.list.map(item => (
                      <label
                        className='inline-flex items-center gap-[8px] cursor-pointer relative'
                        htmlFor={item.slug ?? ''}
                        key={item.slug}>
                        <input
                          type='radio'
                          id={item.slug!}
                          checked={
                            item.slug ===
                            searchParams[
                              (el.filterName.slug as keyof TSearchParams) ??
                                'duration'
                            ].slug
                          }
                          onChange={e =>
                            setSearchParams((prev: TSearchParams) => ({
                              ...prev,
                              [(el.filterName.slug as keyof TSearchParams) ??
                              'duration']: item
                            }))
                          }
                          className='peer hidden'
                        />
                        <span className='w-[17px] h-[17px] rounded-full bg-[#F0F0F0] border border-[#F0F0F0] peer-checked:border-accent peer-checked:bg-white' />
                        {/* Внутренний кружок */}
                        <span className='w-[11px] h-[11px] rounded-full bg-[#F0F0F0] peer-checked:bg-accent absolute left-[3px] bottom-[3px]' />
                        <span className='font-normal text-black peer-checked:text-accent'>
                          {item.name}
                        </span>
                      </label>
                    ))}
                  </div>
                </AccordionContent>
              </AccordionItem>
            ))}
        </Accordion>
      </div>
      <DrawerClose asChild>
        <Button
          className='mt-auto min-h-[65px]'
          variant='secondary'
          disabled={Object.values(searchParams).every(el => el.slug === 'all')}>
          Применить
        </Button>
      </DrawerClose>
    </DrawerContent>
  )
}
